import * as React from 'react';
import _ from 'lodash';
import clsx from 'clsx';

import { ifClickable } from '../../../utils/touchUtils';
import BaseComponent from '../../BaseComponent';
import IconChevronSmallDown from '../../../icons/IconChevronSmallDown';

interface Props {
  children?: React.ReactNode;
  isOpen: boolean;
  labelId?: string;
  onToggle(): void;
  className?: string;
  disabled?: boolean;
  hideChevron?: boolean;
  'data-testid'?: string;
}

class BasicDropdownTrigger extends BaseComponent<Props> {
  handleToggle() {
    this.props.onToggle();
  }

  handleKeyDown(event: React.KeyboardEvent<HTMLInputElement>) {
    const { disabled, onToggle } = this.props;
    if ((event.key === 'Enter' || event.key === ' ') && !disabled) {
      onToggle();
    }
  }

  render() {
    const { children, className, disabled, hideChevron, isOpen, labelId } = this.props;
    return (
      <div
        aria-labelledby={labelId}
        aria-expanded={isOpen}
        aria-disabled={disabled}
        aria-haspopup
        className={clsx('Select-indicator', 'BasicDropdown-trigger', className, {
          'is-disabled': disabled,
        })}
        onClick={!disabled ? ifClickable(this.handleToggle) : _.noop}
        onKeyDown={this.handleKeyDown}
        role="button"
        tabIndex={0}
        data-testid={this.props['data-testid']}
      >
        <div className="Select-text">{children}</div>

        {!hideChevron && <IconChevronSmallDown />}
      </div>
    );
  }
}

export default BasicDropdownTrigger;
